module.exports = "pegasus/assets/blocks/header-6-theme3.png";